interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("left-ellipsis");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("right-ellipsis");
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-3 py-2 text-sm text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-300"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {buildPages(page, totalPages).map((item) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 min-w-[36px] rounded-md px-2 text-sm transition-colors ${
              item === page
                ? "bg-primary-500 font-medium text-background-950"
                : "border border-background-700 text-foreground-300 hover:border-primary-500 hover:text-primary-400"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-foreground-600">
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-3 py-2 text-sm text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-300"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}